import { NAVBAR_HEIGHT } from '../../constants/layout';

export const navbarFixed = {
  height: NAVBAR_HEIGHT,
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1000,

};



const classNavbarBrand = "fw-bold text-primary me-0 d-none d-lg-block d-flex align-items-center";
const classDivNotification = "d-flex align-items-center";
const classNotificationIcon = "bi bi-bell fs-5 mx-3 d-flex align-items-center";

const classContinerLinks = 'me-auto d-none d-lg-flex justify-content-end w-100';
const classVerticalLink = "d-flex flex-row align-items-center  w-100";
const classHorizontalLink = "d-flex flex-column align-items-center flex-xl-row align-items-xl-center justify-content-center w-80";

export const styles = {
  navbarFixed,
  classNavbarBrand,
  classDivNotification,
  classNotificationIcon,
  classContinerLinks,
  classVerticalLink,
  classHorizontalLink,
};